<template>
  <div>
    <div class="box">
      <div class="box-header" style="display:block;">
        <div class="box-header with-border">
          <h3 class="box-title">Tạo mới dự án</h3>
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-xs-4">
              <div class="form-group">
                <label>{{ $t("newproject.project_code") }}</label>

                <input
                  type="text"
                  class="form-control"
                  v-model="new_project.project_code"
                  :placeholder="$t('newproject.project_code')"
                />
                <span v-show="suggestion_project_code != null">
                  {{ $t("newproject.name_available") }}
                  <span style="color:red"> {{ suggestion_project_code }} </span>
                </span>
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label>{{ $t("newproject.project_name") }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="new_project.project_name"
                  :placeholder="$t('newproject.project_name')"
                />
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label>{{ $t("newproject.project_owner") }}</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('newproject.project_owner')"
                  v-model="new_project.project_owner"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-4">
              <div class="form-group">
                <label>{{ $t("newproject.project_start_date") }}</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('newproject.project_start_date')"
                  v-model="new_project.project_start_date"
                />
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label>{{ $t("newproject.project_status") }}</label>
                <select
                  v-model="new_project.project_status"
                  class="form-control"
                  id="privilege"
                >
                  <option
                    v-for="project_status in project_status_list"
                    v-bind:value="project_status.id"
                    :key="project_status.id"
                    >{{ $t(project_status.text) }}</option
                  >
                </select>
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label>{{ $t("newproject.operator_name") }}</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('newproject.operator_name')"
                  v-model="new_project.operator_name"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-4">
              <div class="form-group">
                <label>{{ $t("newproject.operator_telephone") }}</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('newproject.operator_telephone')"
                  v-model="new_project.operator_telephone"
                />
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label>{{ $t("newproject.operator_website") }}</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('newproject.operator_website')"
                  v-model="new_project.operator_website"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label>{{ $t("newproject.operator_address") }}</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('newproject.operator_address')"
                  v-model="new_project.operator_address"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label>{{ $t("newproject.project_description") }}</label>
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="new_project.project_description"
                ></textarea>
              </div>
            </div>
          </div>
          <!-- start logo image -->
          <div class="row">
            <logo-crop
              @project_logo="ProjectAddLogo"
              :file="uploadFile"
              ref="logoCrop"
            />
            <div class="col-xs-6" style="display:flex; align-items: center;">
              <div
                class="col-xs-6 logo-lg"
                style="display:flex; justify-content:center;"
              >
                <img
                  v-if="!project_logo"
                  :src="img_url.img_default_project"
                  class="resize-img-lg"
                />
                <img v-else :src="project_logo" class="resize-img-lg" />
              </div>
              <div class="col-xs-6">
                <div>
                  <strong>{{ $t("newproject.project_logo") }}</strong>
                </div>
                <button v-if="project_logo === null" @click="triggerInputUploadLogo" style="width:100px;">
                  Upload
                </button>
                <button v-else @click="project_logo = null" class="btn btn-danger" style="width:100px;">
                  <i class="fa fa-trash"></i>
                  {{ $t('project.removeLogo') }}
                </button>
              </div>
            </div>
            <div class="col-xs-6" style="display:flex; align-items: center;">
              <div
                class="col-xs-12 logo-lg"
                style="display:flex; justify-content:center;"
              >
                <img
                  id="stamp-img-id"
                  :src="!new_project.projectStampUrl ? img_url.img_other_no_picture_available : new_project.projectStampUrl"
                  class="resize-img-lg stamp-img-class"
                />
                <!--  -->
                <input
                  id="upload-stamp-img"
                  type="file"
                  accept="image/*"
                  @change="onSelectImg">
              </div>
              <div class="col-xs-6">
                <div>
                  <strong>{{ $t("newproject.projectStamp") }}</strong>
                </div>
                <button v-if="new_project.projectStampUrl === null" @click="onUploadStampImg" style="width:100px;">
                  Upload
                </button>
                <button v-else @click="new_project.projectStampUrl = null" class="btn btn-danger" style="width:100px;">
                  <i class="fa fa-trash"></i>
                  {{ $t('common.delete') }}
                </button>

              </div>
            </div>
          </div>
          <!-- end logo image -->
          <div class="row" style="margin-top: 4rem;">
            <div class="col-xs-12" style="font-size:15pt;">
              <div>{{ $t("newproject.project_module_text") }}</div>
              <div style="margin-top: 2rem;">
                {{ $t("newproject.choose_module_text") }}
              </div>
            </div>
          </div>

          <!-- chon module -->
          <div
            class="row"
            style="display:flex; margin-top: 3rem; font-size: 15pt;"
          >
            <div
              class="col-xs-5"
              style="display:flex; align-items: center; flex-direction: column;"
            >
              <div>{{ $t("newproject.choose_module_options") }}</div>

              <div
                style="height: 400px;padding: 2rem; border: 1px solid; width: 100%; "
              >
                <!-- <div v-for="(module, idx) in allmodule" :key="idx">
                  <div
                    @click="moduleAvailable(module.id, idx)"
                    :class="
                      module.selected ? 'active module_hover' : 'module_hover'
                    "
                  >
                    {{ module.module_name }}
                  </div>
                </div> -->
                <select
                  multiple="multiple"
                  id="lstBox1"
                  class="form-control"
                  style="height: 100%; "
                >
                  <option
                    style=" padding: 8px 10px 8px 10px;  border: 0.5px solid;"
                    @click="moduleAvailable(module.id, idx)"
                    v-for="(module, idx) in allmodule"
                    :key="idx"
                  >
                    {{ module.module_name }}</option
                  >
                </select>
              </div>
            </div>
            <div
              class="col-xs-2"
              style="display:flex; align-items: center; justify-content: center;flex-direction: column;"
            >
              <!-- <button style="width:9rem;" @click="moveToRightModules">
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </button>
              <button
                style="margin-top:3rem;width: 9rem;"
                @click="moveToLeftModules"
              >
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
              </button> -->
              <!-- <input
                type="button"
                id="btnAllRight"
                @click="moveAllRightModules"
                value=">>"
                class="btn btn-default"
              /><br /> -->
              <input
                type="button"
                id="btnRight"
                @click="moveToRightModules"
                value=">"
                class="btn btn-default"
              /><br />
              <input
                type="button"
                id="btnLeft"
                @click="moveToLeftModules"
                value="<"
                class="btn btn-default"
              /><br />
            </div>
            <div
              class="col-xs-5"
              style="display:flex; align-items: center; flex-direction: column;"
            >
              <div>{{ $t("newproject.choosed_modules") }}</div>
              <div
                style="height: 400px;padding: 2rem; border: 1px solid; width: 100%;"
              >
                <select
                  multiple="multiple"
                  id="lstBox2"
                  class="form-control"
                  style="height: 100%;"
                >
                  <option
                    style=" padding: 8px 10px 8px 10px; border: 0.5px solid;"
                    @click="modulePurpose(module.id, idx)"
                    v-for="(module, idx) in purposeModules"
                    :key="idx"
                  >
                    {{ module.module_name }}</option
                  >
                </select>
                <!-- <div v-for="(module, idx) in purposeModules" :key="idx">
                  <div
                    @click="modulePurpose(module.id, idx)"
                    :class="
                      module.selected ? 'active module_hover' : 'module_hover'
                    "
                  >
                    {{ module.module_name }}
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="box-footer">
          <button class="btn btn-primary pull-right" @click="onSave">
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
    </div>
    <!-- snackbar -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!-- /.modal-dialog -->
    <input
      type="file"
      ref="upload_logo"
      accept="image/*"
      style="display:none"
      @change="onHandleUploadLogo"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import loading from "vue-loading-overlay";
import constantsData from "@/lib/constantsData";
import utils from '@/lib/utils'
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Logo from "@/components/Logo/LogoCrop.vue";
import configuration from "@/lib/config";
import axios from "axios";
import ProjectStatusEnum from "@/enum/projectStatusEnum";

export default {
  name: "ProjectAddNew",
  data() {
    return {
      img_url: configuration.imgUrlConfig,
      new_project: {
        project_code: "",
        project_name: "",
        project_owner: "",
        project_start_date: "",
        operator_name: "",
        operator_telephone: "",
        operator_address: "",
        project_status: ProjectStatusEnum.ACTIVE,
        project_description: "",
        operator_website: "",
        projectStampUrl: null
      },
      projectStampFile: {
        imageFile: null
      },
      project_logo: null,
      project_status_list: constantsData.projectStatusType,
      uploadFile: null,
      isLoading: false,
      allmodule: [],
      allmoduleIndexSelectedList: [],
      purposeModules: [
        {
          module_name: this.$t("sidebar.decentralizationManagement.title"),
          id: 7,
          selected: false,
          isNotChange: true
        },
        {
          module_name: this.$t("sidebar.projectsettings.title"),
          id: 6,
          selected: false,
          isNotChange: true
        },
        {
          module_name: this.$t("sidebar.documentation"),
          id: 14,
          selected: false,
          isNotChange: true
        }
      ],
      purposeModulesIndexSelectedList: [],
      active_el: 0,
      suggestion_project_code: null,
      default_logo: null,
      media_server: {
        domain: "",
        token: ""
      }
    };
  },
  watch: {
    GET_ALL_MODULES_PROJECT_DATA: function() {
      this.allmodule = [];
      this.GET_ALL_MODULES_PROJECT_DATA.forEach(module => {
        if (module.id != 6 && module.id != 7 && module.id != 14) {
          let data = {
            module_name: this.$t(
              "sidebar.decentralizationManagement.modules." + module.module_name
            ),
            id: module.id,
            selected: false
          };
          this.allmodule.push(data);
        }
      });
    },
    GET_TOKEN_UPLOAD_DATA: function() {
      let data = this.GET_TOKEN_UPLOAD_DATA;
      this.media_server.domain = data.domain;
      this.media_server.token = data.token;
    }
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ADD_NEW_PROJECT",
      "GET_ALL_MODULES_PROJECT"
    ]),
    // moveAllRightModules: function(e) {
    //   let selectedOpts = $("#lstBox1 option");
    //   if (selectedOpts.length == 0) {
    //     alert("Nothing to move.");
    //     e.preventDefault();
    //   }
    //   $("#lstBox2").append($(selectedOpts).clone());
    //   $(selectedOpts).remove();
    //   e.preventDefault();
    // },
    moveToRightModules: function(e) {
      var selectedOpts = $("#lstBox1 option:selected");
      if (selectedOpts.length == 0) {
        alert("Nothing to move.");
        e.preventDefault();
      }
      for (
        let j = 0, sizeA = this.allmoduleIndexSelectedList.length;
        j < sizeA;
        j++
      ) {
        for (let i = 0, size = this.allmodule.length; i < size; i++) {
          if (this.allmoduleIndexSelectedList[j] == this.allmodule[i].id) {
            this.allmodule[i].selected = false;
            this.purposeModules.push(this.allmodule[i]);
            this.allmodule.splice(i, 1);
            break;
          }
        }
      }
      this.allmoduleIndexSelectedList = [];
    },
    moveToLeftModules: function(e) {
      var selectedOpts = $("#lstBox2 option:selected");
      if (selectedOpts.length == 0) {
        alert("Nothing to move.");
        e.preventDefault();
      }
      for (
        let j = 0, sizeA = this.purposeModulesIndexSelectedList.length;
        j < sizeA;
        j++
      ) {
        for (let i = 0, size = this.purposeModules.length; i < size; i++) {
          if (
            this.purposeModulesIndexSelectedList[j] ==
              this.purposeModules[i].id &&
            !this.purposeModules[i].isNotChange
          ) {
            this.purposeModules[i].selected = false;
            this.allmodule.push(this.purposeModules[i]);
            this.purposeModules.splice(i, 1);
            break;
          }
        }
      }
      this.purposeModulesIndexSelectedList = [];
    },
    modulePurpose: function(id, idx) {
      let array = this.purposeModules;
      array[idx].selected = !array[idx].selected;
      if (this.purposeModulesIndexSelectedList.indexOf(id) == -1) {
        this.purposeModulesIndexSelectedList.push(id);
      } else {
        this.purposeModulesIndexSelectedList = this.purposeModulesIndexSelectedList.filter(
          moduleId => {
            return moduleId != id;
          }
        );
      }
    },
    moduleAvailable: function(id, idx) {
      let array = this.allmodule;
      array[idx].selected = !array[idx].selected;
      if (this.allmoduleIndexSelectedList.indexOf(id) == -1) {
        this.allmoduleIndexSelectedList.push(id);
      } else {
        this.allmoduleIndexSelectedList = this.allmoduleIndexSelectedList.filter(
          moduleId => {
            return moduleId != id;
          }
        );
      }
    },
    triggerInputUploadLogo: function() {
      this.$refs.upload_logo.click();
    },
    onHandleUploadLogo: function() {
      let file = this.$refs.upload_logo.files[0];
      if (file.size > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("ProjectGeneralSettings.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        this.uploadFile = file;
        this.$refs.logoCrop.inputFile(file);
      }
    },
    ProjectAddLogo: function(data) {
      this.project_logo = data;
    },
    validate: function() {
      let validatedResult = "OK";
      let validate_keys = [
        "project_code",
        "project_name",
        "operator_website",
        "project_owner",
        "project_start_date",
        "operator_name",
        "operator_telephone",
        "operator_address"
      ];
      for (let key in this.new_project) {
        if (validate_keys.indexOf(key) < 0) {
          continue;
        }
        if (this.new_project[key] === null || this.new_project[key] === "") {
          validatedResult = `${this.$t("common.missing")} ${this.$t(
            "newproject." + key
          )}`;
          break;
        } else {
          //
        }
      }
      return validatedResult;
    },
    onSave: function() {
      let result = this.validate();
      if (result == "OK") {
        this.suggestion_project_code = null;
        let module_ids = [];
        this.purposeModules.forEach(el => {
          module_ids.push(el.id);
        });
        let data = {
          project_name: this.new_project.project_name,
          project_code: this.new_project.project_code,
          project_logo: this.project_logo,
          project_description: this.new_project.project_description,
          project_owner: this.new_project.project_owner,
          project_start_date: utils.formatSqlDate(this.new_project.project_start_date, "DD/MM/YYYY", "YYYY-MM-DD[T]HH:mm:ss"),
          project_status: this.new_project.project_status,
          operator_name: this.new_project.operator_name,
          operator_telephone: this.new_project.operator_telephone,
          operator_website: this.new_project.operator_website,
          operator_address: this.new_project.operator_address,
          moduleIds: module_ids,
          project_stamp: this.new_project.projectStampUrl
        };
        this.ADD_NEW_PROJECT(data)
          .then(
            function() {
              this.SUCCESS_TOAST();
              this.$router.push({
                name: "DashBoard"
              });
            }.bind(this)
          )
          .catch(
            function(error) {
              let error_code = error.response.data.message;
              this.suggestion_project_code =
                error.response.data.suggestion_code;
              if (error_code == "project_code_existed") {
                this.ON_SHOW_TOAST({
                  message: this.$t("newproject.projectcode_existed"),
                  styleType: "danger"
                });
              } else {
                this.ON_SHOW_TOAST({
                  message: error,
                  styleType: "danger"
                });
              }
            }.bind(this)
          );
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },
    onSelectImg: function(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.getResultFile(files[0])
      this.new_project.projectStampUrl = URL.createObjectURL(files[0])
      this.uploadBannerImage()
    },
    getResultFile: function(file) {
      let vm = this;
      vm.projectStampFile.imageFile = file;
    },
    onUploadStampImg: function() {
      $('#upload-stamp-img').click()
    },
    uploadBannerImage: async function () {
      let formData = new FormData()
      formData.append('file', this.projectStampFile.imageFile)
      formData.append('directory', 'project/stamp')
      formData.append('forceOverride', true)
      await axios({
        method: 'POST',
        timeout: 6000,
        url: this.media_server.domain + '/api/v1/upload/',
        data: formData,
        headers: { Authorization: `JWT ${this.media_server.token}` }
      }).then(
        async function (res) {
          let data = res.data
          this.new_project.projectStampUrl = data.domain + data.url
        }.bind(this)
      ).catch(
        async function () {
          this.new_project.projectStampUrl = null
        }.bind(this)
      )
    },
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ALL_MODULES_PROJECT_DATA",
      "GET_TOKEN_UPLOAD_DATA"
    ])
  },
  mounted() {
    $(function () {
      $('#stamp-img-id').on('click', function () {
        $('#upload-stamp-img').click()
      })
    })
  },
  created() {
    this.GET_ALL_MODULES_PROJECT();
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: loading,
    "logo-crop": Logo
  }
};
</script>

<style lang="scss" scoped>
.resize-img-lg {
  height: auto;
  width: auto;
  max-width: 70px;
  max-height: 70px;
}
.module_hover:hover {
  cursor: pointer;
  background-color: #b7a5a5;
}
.module_hover.active {
  background-color: #b7a5a5;
}
input[type="file"] {
  display: none;
}
.stamp-img-class {
  max-height: 60px;
  max-width: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Project/ProjectAddNew.vue